<template>
  <div>
    <div v-if="isSetRemoteLock">
      <div v-loading="cardList.loading" :element-loading-text="$t('ctcirl1')">
        <div style="font-size:18px;font-weight:bold;margin-bottom: 16px;">{{ $t('ctcirl2') }} <i class="el-icon-refresh"
            style="cursor: pointer;" @click="getCardInfo"></i></div>
        <div style="height: 300px;">
          <el-table :data="cardList.RxTx" style="width: 100%" border height="100%">
            <el-table-column type="index" :label="$t('ctcirl3')" width="50">
            </el-table-column>
            <el-table-column prop="type" :label="$t('ctcirl4')" width="80">
            </el-table-column>
            <el-table-column prop="version" :label="$t('ctcirl5')">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="flex-b-c" style="margin-top: 16px;">
        <el-button type="danger" @click="handleLock(1)">{{ $t('ctcirl6') }}</el-button>
        <el-button type="warning" @click="handleLock(2)">{{ $t('ctcirl7') }}</el-button>
        <el-button type="primary" @click="handleLock(0)">{{ $t('ctcirl8') }}</el-button>
      </div>
    </div>
    <div v-else>
      <div v-if="!remoteLockPassword" class="flex-b-c">
        <el-input :placeholder="$t('ctcirl9')" v-model="password" show-password></el-input>
        <el-button style="margin-left: 16px;" @click="setRemoteLockPass">{{ $t('ctcirl10') }}</el-button>
      </div>
      <div v-else class="flex-b-c">
        <el-input :placeholder="$t('ctcirl9')" v-model="password" show-password></el-input>
        <el-button style="margin-left: 16px;" @click="authentication">{{ $t('ctcirl11') }}</el-button>
      </div>

    </div>
    <msg-dialog :title="$t('ctcirl12')" :dialogVisible="dialogVisible" @closeDialog="closeDialog" :isAppend="true"
      dtop="30vh" :buttonName="[$t('ctcirl13'), $t('ctcirl14')]">
      <div class="flex-a-c">{{ $t('ctcirl15') }}: <el-date-picker v-model="datePicker" type="datetime"
          :placeholder="$t('ctcirl16')"></el-date-picker></div>
      <div style="font-size:12px;padding-top:8px">{{ $t('ctcirl17') }}</div>
    </msg-dialog>

  </div>
</template>

<script>
import $md5 from 'js-md5';
import MsgDialog from "@/components/basics/MsgDialog";

export default {
  name: "RemoteLock",
  props: {
    currentDetail: {
      type: Object
    }
  },
  data() {
    return {
      isSetRemoteLock: false,
      remoteLockPassword: '',
      password: '',
      passwordError: 0,
      cardList: {
        rxCard: [],
        txCard: [],
        RxTx: [],
        loading: true
      },
      datePicker: new Date(),
      dialogVisible: false
    }
  },
  created() {
    const { remoteLock } = this.currentDetail;
    this.remoteLockPassword = remoteLock;
  },
  mounted() {
    this.onMessageInit();
  },
  methods: {
    onMessageInit() {
      this.WebSocket.onmessage = (val) => {
        let info = JSON.parse(val.data);
        const { type, data } = info;
        if (type === "invoke_method") {
          const { uri } = data;
          if (uri === "getCardInfo") {
            const { rxCardList, txCard: txCardList } = JSON.parse(data.response).data;
            let rxCard = [];
            let txCard = [txCardList];
            rxCardList.forEach((list) => { rxCard = [...rxCard, ...list]; });
            rxCard = rxCard.map((card) => ({ 'version': card.version.split('ID号')[0] }));
            const RxTx = rxCard.map((item) => { item.type = this.$t('ctcip15'); return item; }).concat(txCard.map((item) => { item.type = this.$t('ctcip14'); return item; })).map((rt, index) => {
              rt.key = index;
              return rt;
            })
            this.cardList = { RxTx, rxCard, txCard, loading: false };
          }
          if (uri === "projectLock") {
            this.$msg({ message: this.$t('ctcirl20'), type: "success", showClose: true });
            setTimeout(() => { this.getCardInfo(); }, 10000);
          }
        }
      }
    },
    setRemoteLockPass() {

      if (this.password === "") { return false; }

      const { id } = this.currentDetail;

      const remoteLock = $md5(this.password);

      this.$http.post("/admin/device/setRemoteLock", { id, remoteLock }, () => {
        this.remoteLockPassword = remoteLock;
        this.password = "";
      });

    },
    authentication() {
      if (this.remoteLockPassword === $md5(this.password)) {
        this.isSetRemoteLock = true;
        this.getCardInfo();
      } else {
        this.$msg({ message: this.$t('ctcirl21'), type: "warning", showClose: true });
        this.passwordError += 1;
        this.passwordError === 3 && (this.$router.go(0));
      }
    },
    handleLock(type) {
      console.log(type);
      switch (type) {
        case 0:
        case 1:
          this.setProjectLock(type);
          break;
        case 2:
          this.dialogVisible = true;
          break;
        default:
          break;
      }
      // console.log(this.getDate());
      // console.log(this.getVerifyCode());
    },
    closeDialog(confirm) {
      if (confirm) {
        this.setProjectLock(1, this.getDate(this.datePicker));
      }
      this.dialogVisible = false;
    },
    setProjectLock(lock, lockTime = this.getDate()) {
      this.sendCmd([{
        type: "invoke_method", data: {
          methodName: "projectLock",
          methodParams: {
            lock,
            lockTime,
            verifyCode: this.getVerifyCode()
          }
        }
      }], 'set');
    },
    getCardInfo() {
      this.cardList = { rxCard: [], txCard: [], RxTx: [], loading: true };
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getCardInfo", methodParams: {} } }], 'get');
      setTimeout(() => {
        this.cardList.loading = false;
      }, 5000);
    },
    sendCmd(commands_info, type = "set") {
      this.onMessageInit();
      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, res => {
        console.log(res);
      });
    },
    getDate(date = new Date()) {
      const y = date.getFullYear();
      const m = date.getMonth();
      const d = date.getDate();
      const h = date.getHours();
      const mm = date.getMinutes();
      return `${this.formatting(y).slice(2, 4)}${this.formatting(m + 1)}${this.formatting(d)}${this.formatting(h)}${this.formatting(mm)}`;
    },
    formatting(time, len = 2) {
      let strTime = time + '';
      while (strTime.length < len) {
        strTime = '0' + strTime
      }
      return strTime;
    },
    getVerifyCode() {
      const { sn } = this.currentDetail;
      const md = $md5(sn);
      return md.slice(0, 4) + md.slice(28, 32);
    },
  },
  computed: {
    WebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  components: {
    MsgDialog
  }
}
</script>

<style></style>